import { Link } from 'react-router';
import { visibleOptionLabel } from '@/lib/catalog/optionLabel';
import { SectionCard } from '@/components/ui';
import type { LowStockAlert } from '../types/dashboardWidget';

interface LowStockListProps {
  items?: LowStockAlert[] | undefined;
  isLoading?: boolean | undefined;
  title: string;
  labels: {
    product: string;
    stock: string;
    viewAll: string;
    empty: string;
  };
}

export const LowStockList = ({
  items,
  isLoading,
  title,
  labels,
}: LowStockListProps) => (
  <SectionCard
    title={title}
    aside={
      <Link
        to="/products"
        className="rounded-full px-3 py-1 text-xs font-medium transition-all hover:bg-[color:var(--surface-1)]"
        style={{ color: 'var(--content-muted)', border: '1px solid var(--divider-soft)' }}
      >
        {labels.viewAll} →
      </Link>
    }
  >
    {isLoading ? (
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="h-8 animate-pulse rounded"
            style={{ background: 'var(--surface-1)' }}
          />
        ))}
      </div>
    ) : (items ?? []).length === 0 ? (
      <p
        className="py-8 text-center text-sm"
        style={{ color: 'var(--content-muted)' }}
      >
        {labels.empty}
      </p>
    ) : (
      <ul className="space-y-2">
        {(items ?? []).slice(0, 4).map((item) => {
          const isCritical = (item.currentQty ?? 0) === 0;
          return (
            <li
              key={item.productId}
              className="flex items-center justify-between gap-3 rounded-lg px-3 py-2"
              style={{
                background: isCritical
                  ? 'var(--status-danger-bg)'
                  : 'var(--surface-1)',
              }}
            >
              <div className="min-w-0 flex-1">
                <Link
                  to={`/products/${item.productId}`}
                  className="block truncate text-sm font-medium hover:underline"
                  style={{ color: 'var(--content-strong)' }}
                >
                  {item.productName}
                </Link>
                {visibleOptionLabel(item.variantLabel) ? (
                  <span
                    className="block truncate text-xs"
                    style={{ color: 'var(--content-muted)' }}
                  >
                    {visibleOptionLabel(item.variantLabel)}
                  </span>
                ) : null}
              </div>
              <span
                className="shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold tabular-nums"
                style={{
                  background: isCritical
                    ? 'var(--status-danger-fg)'
                    : 'var(--status-warn-bg)',
                  color: isCritical ? '#fff' : 'var(--status-warn-fg)',
                }}
              >
                {item.currentQty ?? 0}
              </span>
            </li>
          );
        })}
      </ul>
    )}
  </SectionCard>
);
